import { Box, Chip } from '@mui/material';
import { useIntl } from 'react-intl';
import { AUDIOGRAM_TARGET_VARIANTS } from '../consts';

interface Props {
  variants: string[];
  value: string;
  onChange: (value: string) => void;
}

export function VariantSelector({ variants, value, onChange }: Props) {
  const { $t } = useIntl();
  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
      {AUDIOGRAM_TARGET_VARIANTS.filter((v) => variants.includes(v.value)).map((v) => (
        <Chip
          variant="outlined"
          key={v.value}
          label={$t(v.message)}
          onClick={() => onChange(v.value)}
          color={value === v.value ? 'primary' : 'default'}
          sx={{
            fontSize: '12px',
            opacity: value === v.value ? 1 : 0.8,
          }}
        />
      ))}
    </Box>
  );
}
